import type { ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './styles.module.css';

export function ManualAddress(): ReactNode {
  return (
    <div className={styles.ManualAddress}>
      <Icon name="pencil" />
      <span>Saisir mon adresse manuellement</span>
    </div>
  );
}
